var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrescriptionsBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 15.7886C2.375 17.0261 3.44375 18.0386 4.75 18.0386H14.25C15.5562 18.0386 16.625 17.0261 16.625 15.7886L17.8125 2.28857H1.1875L2.375 15.7886ZM3.5625 3.41357H15.4375L14.25 15.7886H4.75L3.5625 3.41357ZM0 0.0385742V2.28857H19V0.0385742H0Z",
    fill: "#255986"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08897 15.4277C8.66014 14.9577 8.71162 14.2498 9.20397 13.8467L12.8119 10.8928C13.3042 10.4897 14.051 10.544 14.4798 11.0141C14.9086 11.4842 14.8571 12.1921 14.3648 12.5952L10.7569 15.5491C10.2646 15.9522 9.5178 15.8978 9.08897 15.4277Z",
    fill: "#255986"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99088 15.7895C6.37028 15.9904 5.68774 15.6559 5.46639 15.0423L3.9638 10.8771C3.74245 10.2635 4.0661 9.60315 4.68669 9.40222C5.30729 9.20129 5.98982 9.53583 6.21118 10.1494L7.71376 14.3146C7.93512 14.9283 7.61147 15.5886 6.99088 15.7895Z",
    fill: "#255986"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8643 12.6036C10.4258 13.0656 9.67721 13.1053 9.1923 12.6923L5.65001 9.67498C5.16509 9.26193 5.12746 8.55255 5.56596 8.09052C6.00445 7.62849 6.75302 7.58878 7.23793 8.00183L10.7802 11.0191C11.2651 11.4321 11.3028 12.1415 10.8643 12.6036Z",
    fill: "#255986"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescriptionsBase);
export default __webpack_public_path__ + "static/media/prescriptions_base.c15692689651d49eaf80c665565a21fe.svg";
export { ForwardRef as ReactComponent };